import get from 'lodash/get'

/**
 * Check if at least one permission is truthy in an n-nested object of permissions
 * @param {Object} object - the permission object to verify
 *
 * @return {Boolean} whether or not the object contains a truthy permission
 */
function hasSubPermission(object) {
  return !!Object.values(object).find(value => (typeof value === 'object' ? hasSubPermission(value) : value === true))
}

/**
 * Check if a permission object contains a truthy permission at some path
 *
 * @param {Object} object - The permission object to verify
 * @param {String} path - The path where to get the permission
 *
 * @return {Boolean} whether or not the permission has been found
 */
export function hasPermission(object, path) {
  const permission = get(object, path)
  switch (typeof permission) {
    case 'undefined':
      return false
    case 'boolean':
      return permission
    case 'object':
      return hasSubPermission(permission)
    default:
      throw new Error(`Permission "${path}" : expecting a boolean or an object, received ${typeof permission}`)
  }
}

window.hasPermission = hasPermission
